export const query = (key: string) => new URLSearchParams(window.location.search).get(key);
